import React from 'react';
import { Alert, Label } from 'reactstrap';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import FormLayout from '~/components/formLayout/formLayout';

const renderInput = (name, label, errors, showError = true) => (
  <div className="mb3">
    <Label>{label}</Label>
    <FormikInputField name={name} invalid={showError && !!errors[name]} />
    {showError && errors.name && <p className="error">{errors[name]}</p>}
  </div>
);

const BreweryForm = ({ errors, touched, handleSubmit, isSubmitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="Address">
        {renderInput('name', 'Name', errors)}
        {renderInput('streetAddress', 'Street address', errors)}
        {renderInput('streetAddress2', 'Street address 2', errors, false)}
        {renderInput('suburb', 'Suburb', errors, false)}
        {renderInput('city', 'City', errors)}
        {renderInput('postcode', 'Post code', errors)}
        <div className="mb3">
          <Label>Country</Label>
          <FormikInputField name="country.name" disabled />
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Customs details">
        {renderInput('settings.licenceNumber', 'Customs licence number', errors)}
        {renderInput(
          'settings.transferReportAdvanceDays',
          'Number of days in advance to run the transfer report',
          errors
        )}
        {renderInput('settings.reportEmailAddress', 'Email address to send customs reports to', errors)}
      </FormLayout>
      <FormLayout className="mt4" title="Other">
        {renderInput('settings.consolidatedLotPrefix', 'Consolidated Lot Prefix', errors)}
        {renderInput('settings.defaultLotVolume', 'Default Lot Volume (L)', errors)}
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton data-qa="hscode-save" color="primary" type="submit" isSubmitting={isSubmitting}>
          Save
        </SubmissionButton>
      </div>
    </form>
  );
};

export default BreweryForm;



// WEBPACK FOOTER //
// ./src/components/breweryForm/breweryForm.jsx